module.exports = __webpack_public_path__ + "img/tlf_yqltdn.4ece8e32.png";